import React from 'react';

interface IProps {
  style?: any;
}

const EditIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="21" fill="none" viewBox="0 0 23 21">
      <path fill={props.style?.fillColor ? props.style.fillColor : "#204078"} d="M14.636 11.392L13.01 16.27 0 17.896l10.57-10.57 4.066 4.066zM11.422 4.89l-.813.813 7.32 7.319.813-.814-7.32-7.318zM17.883 0l-4.88 4.879 4.88 4.879 4.879-4.88L17.882 0zM23 19.047H0v1.15h23v-1.15z"/>
    </svg>
  )
}

export default EditIcon;